import React from 'react';
import { Stage, Layer, Rect, RegularPolygon, Arrow, Text, Circle } from 'react-konva';

const WIDTH = 250;
const HEIGHT = 420;
const PADDING = 50;
const LINE_SPACING = 50;

const COLORS = {
  white: '#FFFFFF',
  green: '#3ec46d',
  blue: '#00B8FF',
  red: '#E15A8B',
  purple: '#A97FFF',
  background: '#142831',
};

interface SideViewTextLegendProps { }
const FONT_FAMILY = "'Poppins', sans-serif";

export default function SideViewTextLegend({ }: SideViewTextLegendProps) {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        outline: '1px solid #ccc',
        backgroundColor: COLORS.background,
        width: WIDTH,
        height: HEIGHT,
      }}
    >
      <Stage width={WIDTH} height={HEIGHT}>
        <Layer>
          {/* Start: Green triangle */}
          <Circle
            x={PADDING + 10}
            y={PADDING + LINE_SPACING * 0}
            radius={7}
            fill={COLORS.green}
          />
          <Text
            text="Start"
            x={PADDING + 30}
            y={PADDING + LINE_SPACING * 0 - 8}
            fill={COLORS.white}
            fontSize={14}
            fontFamily={FONT_FAMILY}
          />

          {/* End: Purple rectangle */}
          <Circle
            x={PADDING + 10}
            y={PADDING + LINE_SPACING * 1}
            radius={7}
            fill="#FFA500"
          />
          <Text
            text="End"
            x={PADDING + 30}
            y={PADDING + LINE_SPACING * 1 - 8}
            fill={COLORS.white}
            fontSize={14}
            fontFamily={FONT_FAMILY}
          />

          {/* Head Position: circle icon */}
          <Circle
            x={PADDING + 10}
            y={PADDING + LINE_SPACING * 2}
            radius={7}
            fill={COLORS.white}
          />
          <Text
            text="Head position"
            x={PADDING + 30}
            y={PADDING + LINE_SPACING * 2 - 8}
            fill={COLORS.white}
            fontSize={14}
            fontFamily={FONT_FAMILY}
          />

          {/* Optimal Motion: Blue arrow */}
          <Arrow
            points={[
              PADDING + 4,
              PADDING + LINE_SPACING * 3,
              PADDING + 50,
              PADDING + LINE_SPACING * 3,
            ]}
            stroke={COLORS.blue}
            fill={COLORS.blue}
            strokeWidth={3}
            pointerLength={8}
            pointerWidth={8}
          />
          <Text
            text="Optimal motion"
            x={PADDING + 60}
            y={PADDING + LINE_SPACING * 3 - 8}
            fill={COLORS.white}
            fontSize={14}
            fontFamily={FONT_FAMILY}
          />

          {/* User Motion: White arrow */}
          <Arrow
            points={[
              PADDING + 4,
              PADDING + LINE_SPACING * 4,
              PADDING + 60,
              PADDING + LINE_SPACING * 4,
            ]}
            stroke={COLORS.white}
            fill={COLORS.white}
            strokeWidth={3}
            pointerLength={8}
            pointerWidth={8}
          />
          <Text
            text="User motion"
            x={PADDING + 70}
            y={PADDING + LINE_SPACING * 4 - 8}
            fill={COLORS.white}
            fontSize={14}
            fontFamily={FONT_FAMILY}
          />
          {/* Linear Error: Red arrow */}
          <Arrow
            points={[
              PADDING + 4,
              PADDING + LINE_SPACING * 5,
              PADDING + 60,
              PADDING + LINE_SPACING * 5,
            ]}
            stroke={COLORS.red}
            fill={COLORS.red}
            strokeWidth={3}
            pointerLength={8}
            pointerWidth={8}
          />
          <Text
            text="Linear error"
            x={PADDING + 70}
            y={PADDING + LINE_SPACING * 5 - 8}
            fill={COLORS.white}
            fontSize={14}
            fontFamily={FONT_FAMILY}
          />

        </Layer>
      </Stage>
    </div>
  );
}
